/**
 * Send SMS to the client and owner via backend API
 */
export async function sendSMSToClient(bookingData) {
  try {
    const clientMessage = `Hi ${bookingData.name}, your booking for ${
      bookingData.service
    }${bookingData.subService ? ` - ${bookingData.subService}` : ""} on ${
      bookingData.date
    } at ${bookingData.time} for ${
      bookingData.attendees
    } person(s) is confirmed.`;

    const response = await fetch(
      "https://asia-south2-barma-sorig.cloudfunctions.net/sendSms",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: bookingData.phone,
          name: bookingData.name,
          service: bookingData.service,
          subService: bookingData.subService,
          date: bookingData.date,
          time: bookingData.time,
          attendees: bookingData.attendees,
          message: clientMessage,
        }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        `SMS notification failed: ${data.error || "Unknown error"}`
      );
    }

    return true;
  } catch (error) {
    console.error("SMS notification error:", error.message);
    throw error;
  }
}
